import { render, staticRenderFns } from "./accessuserAdd.vue?vue&type=template&id=2fbb28bc&scoped=true&"
import script from "./accessuserAdd.vue?vue&type=script&lang=js&"
export * from "./accessuserAdd.vue?vue&type=script&lang=js&"
import style0 from "./accessuserAdd.vue?vue&type=style&index=0&id=2fbb28bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbb28bc",
  null
  
)

export default component.exports